import {http} from "@/services/config";

export default {
    loadCnpj: (cnpj) => {
        return http.get(`api/v1/beneficiarios/listar/cnpj/${cnpj}`)
    }
}
